var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgAllAiGenerateAbled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.3333V21.2162C25 23.3059 23.3059 25 21.2162 25H10.7838C8.69406 25 7 23.3059 7 21.2162V10.7838C7 8.69406 8.69406 7 10.7838 7H16.871H17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11C19.1538 11 21 9.16487 21 7C21 9.14163 22.8462 11 25 11C22.8462 11 21 12.7143 21 15C21 12.7143 19.1538 11 17 11Z",
    fill: "#6360F6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6C25.2 6 26 5.2 26 4C26 5.2 26.8 6 28 6C26.8 6 26 6.8 26 8C26 6.8 25.2 6 24 6Z",
    fill: "#6360F6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0125L16 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.0281L19.9999 18.9988",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgAllAiGenerateAbled);
export default __webpack_public_path__ + "static/media/iconImgAllAiGenerateAbled.a5882d717cb54874e7cf3d509bb560b2.svg";
export { ForwardRef as ReactComponent };